import { createRouter, createWebHistory } from 'vue-router';

const modulesFiles = require.context('./modules', true, /\.js$/);

const routes = modulesFiles.keys().reduce((accumulator, modulePath) => {
  const value = modulesFiles(modulePath);
  return accumulator.concat(value.default);
}, []);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
